/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */

import { MarkupBaseJson, MarkupFillType } from 'common/type-markup';
import MathHelper from 'container/pdf-viewer/helper/math.helper';
import { ArcElementCanvas } from '../markup-canvas-elements/markup.arc-canvas.element';
import { GripPoint, MarkupBaseBounding } from '../markup-canvas-elements/markup.bounding.element';
import { RotateTooltipElement } from '../markup-canvas-elements/markup.rotate-tooltip.element';
import { MarkupBaseItem } from './markup.base.item';
export class MarkupEllipseItem extends MarkupBaseItem {
    private ellipseHTML: ArcElementCanvas = new ArcElementCanvas(false);
    private _uniqueId: string;
    public constructor(viewer: Communicator.WebViewer) {
        super(viewer);
        this.iconName = 'markupEllipse';
        this.shapeName = 'Ellipse';
        this._uniqueId = this.uniqueId;
        const ellipseItem = this;
        this.rotateTooltip = new RotateTooltipElement();
        this.redlineBounding = new MarkupBaseBounding(viewer);
        this.redlineBounding.setCanRotate(true);
        this.redlineBounding.setGripPointCallback(
            (point: Communicator.Point2, type: GripPoint) => {
                ellipseItem.gripPointDragStartCallback(point, type);
            },
            (point: Communicator.Point2) => {
                ellipseItem.gripPointDragMoveCallback(point);
            },
            (point: Communicator.Point2) => {
                ellipseItem.gripPointDragEndCallback(point);
            });
        this.redlineBounding.setRotateGripPointCallback(
            (point: Communicator.Point2, type: GripPoint) => {
                ellipseItem.gripPointDragStartCallback(point, type);
            },
            (point: Communicator.Point2, tooltipPos: Communicator.Point2) => {
                this.rotateGripPointDragMoveCallback(point, tooltipPos);
            },
            (point: Communicator.Point2) => {
                ellipseItem.rotateGripPointDragEndCallback(point);
            },
        );
        this.redlineBounding.setBoundingBoxClickCallback(
            (point: Communicator.Point2, event: MouseEvent) => this.onClickBoundingCallBack(event),
        );
        this.redlineBounding.createBoundingBox();
    }
    setPosition(point: Communicator.Point3) {
        if (point) {
            this._point1 = point;
        }
    }
    setRadiusPoint(radPoint: Communicator.Point3) {
        this._point2 = radPoint;
    }
    public setMoveGripPoint(point: Communicator.Point2): void {
        return
    }
    private _update(): void {
        if (!this._point1) return;
        this.ellipseHTML.setStrokeWidth(this._lineWeight);
        this.ellipseHTML.setStrokeColor(new Communicator.Color(this._lineColor.r, this._lineColor.g, this._lineColor.b));
        this.ellipseHTML.setFillType(this._fillColorOption ? MarkupFillType.Opaque : MarkupFillType.None);
        this.ellipseHTML.setFillColor(new Communicator.Color(this._fillColor.r, this._fillColor.g, this._fillColor.b));
        this.ellipseHTML.setFillOpacity(this._lineOpacity);
        this.ellipseHTML.setLineStyle(this._lineStyle);
        this.ellipseHTML.setStartArc(0);
        this.ellipseHTML.setEndArc(Math.PI * 2);

        this.ellipseHTML.setRotation(this._rotation);
        if (this.redlineBounding) {
            this.redlineBounding.setRotation(this._rotation);
            this.redlineBounding.updateGripPoints();
            this.redlineBounding.updateRotationTransform(this._rotation);
        }
        this.updateRotateTransform(this._rotation);

        const { view } = this._viewer;
        const firstPoint = Communicator.Point2.fromPoint3(
            view.projectPoint(this._point1.copy()),
        );
        this.ellipseHTML.setFirstPoint(firstPoint);
        let secondPoint = firstPoint.copy();
        if (this._point2 !== null) {
            secondPoint = Communicator.Point2.fromPoint3(
                view.projectPoint(this._point2.copy()),
            );
            const b = new Communicator.Point2(Math.min(firstPoint.x, secondPoint.x), Math.min(firstPoint.y, secondPoint.y));
            const a = new Communicator.Point2(Math.max(firstPoint.x, secondPoint.x), Math.max(firstPoint.y, secondPoint.y));
            const size = Communicator.Point2.subtract(a, b);
            this._isReady = true;
            this.ellipseHTML.setFirstPoint(b);
            this.ellipseHTML.setSize(size);
        }
        this.updateBoundingBox(firstPoint, secondPoint);
    }
    public draw(): void {
        this._update();
        if (!this.isHiding) {
            if (this._isReady) {
                this._redlineElementId = this._viewer.markupManager.addMarkupElement(
                    this.ellipseHTML.getArcCanvas()
                );
                if (this.rotateTooltip) {
                    this.rotateTooltipId = this._viewer.markupManager.addMarkupElement(
                        this.rotateTooltip.getRotateTooltip(),
                    );
                }
            }
        } else {
            this._redlineElementId && this._viewer.markupManager.removeMarkupElement(this._redlineElementId);
            this._redlineElementId = null;
            this.rotateTooltipId && this._viewer.markupManager.removeMarkupElement(this.rotateTooltipId);
            this.rotateTooltipId = null;
        }

        this.handleBoundingRectInteraction();
    }

    updateBoundingBox(firstPoint: Communicator.Point2, secondPoint: Communicator.Point2) {
        const pos = this.ellipseHTML.getFirstPoint();
        const size = this.ellipseHTML.getSize();
        const stroke = this.ellipseHTML.getStrokeWidth();
        const boxPos = new Communicator.Point2(pos.x - stroke / 2, pos.y - stroke / 2);
        if (this.redlineBounding) {
            this.redlineBounding.setCenter(firstPoint, secondPoint);
            this.redlineBounding.setPosition(boxPos);
            this.redlineBounding.setSize(new Communicator.Point2(size.x + stroke, size.y + stroke));
        }

    }
    public getClassName(): string {
        return "Communicator.Markup.MarkupEllipseItem";
    }
    toJson(): MarkupBaseJson {
        const ellipseObj = {
            className: this.getClassName(),
            lineColor: this._lineColor,
            lineWeight: this._lineWeight,
            lineOpacity: this._lineOpacity,
            fillColor: this._fillColor,
            fillColorOption: this._fillColorOption,
            iconName: this.iconName,
            shapeName: this.shapeName,
            uniqueIdGroup: this.uniqueIdGroup,
            uniqueId: this.uniqueId,
            point1: this._point1?.copy(),
            point2: this._point2?.copy(),
            lineStyle: this._lineStyle,
            rotation: this._rotation,
            modifiedDate: this._modifiedDate,
            lastModifiedBy: this._lastModifiedBy,
        };
        return ellipseObj;
    }
    fromJson(data: any): void {
        this._lineColor = data.lineColor;
        this._lineOpacity = data.lineOpacity;
        this._lineStyle = data.lineStyle;
        this._lineWeight = data.lineWeight;
        this._fillColor = data.fillColor
        this._fillColorOption = data.fillColorOption;
        this.uniqueIdGroup = data.uniqueIdGroup;
        this._uniqueId = data.uniqueId;
        this._point1 = data.point1;
        this._point2 = data.point2;
        this._rotation = data.rotation;
        this._modifiedDate = data.modifiedDate;
        this._lastModifiedBy = data.lastModifiedBy;
    }
    gripPointDragStartCallback(point: Communicator.Point2, type: GripPoint) {
        this.isUpdate = false;
        if (!this._isCanEdit) return;
        this.gripPointDragType = type;
        this.updateOppositePoint();
    }
    rotateGripPointDragMoveCallback(point: Communicator.Point2, tooltipPos: Communicator.Point2) {
        if (this.gripPointDragType === null) return;
        if (!this.isUpdate) this.updateDefinePoints();
        this.isUpdate = true;
        const a = this._viewer.view;
        const b = a.getCamera().getCameraPlaneIntersectionPoint(point, a);
        if (b) {
            const boundRects = this.getHTMLElement().getBoundingClientRect();
            const pointX = boundRects.left + boundRects.width / 2;
            const pointY = boundRects.top + boundRects.height / 2;
            const rotateAngle = ((Math.atan2(point.y - pointY, point.x - pointX) + Math.PI / 2) * 180 / Math.PI - 180) % 360;
            this.setRotation(rotateAngle);
            if (this.rotateTooltip) {
                this.rotateTooltip.setPosition(tooltipPos);
                this.rotateTooltip.setRotateValue(rotateAngle);
                this.rotateTooltip.setVisible(true);
                this.rotateTooltip.draw();
            }
            this._update();
            if (this.redlineBounding) {
                this.redlineBounding.setRotation(rotateAngle);
                this.redlineBounding.updateGripPoints();
            }
        }
    }
    onDragStart(point: Communicator.Point2) {
        this.isUpdate = false;
        const a = this._viewer.view;
        const b = a.getCamera().getCameraPlaneIntersectionPoint(point, a);
        b !== null && this._previousDragPlanePosition.assign(b);
        return !1;
    }

    onDragMove(point: Communicator.Point2) {
        this.isUpdate = true;
        const a = this._viewer.view;
        const b = a.getCamera().getCameraPlaneIntersectionPoint(point, a);
        let c = null;
        if (b !== null) {
            c = Communicator.Point3.subtract(b, this._previousDragPlanePosition);
            this._point1!.add(c);
            this._point2!.add(c);
            this._previousDragPlanePosition.assign(b);
        }
        this._viewer.markupManager.refreshMarkup();
        return !0;
    }
    hit(point: Communicator.Point2) {
        let ct = Communicator.Point2.zero();
        if (this.redlineBounding) ct = this.redlineBounding.center;
        const pos = MathHelper.convertPointWithRotation(point, ct, 360 - this._rotation);
        return this.ellipseHTML.hit(pos);
    }
    setMarkupVisible(visible: boolean): void {
        this.ellipseHTML.baseCanvas.style.display = visible ? 'initial' : 'none';
        super.setMarkupVisible(visible);
    }
    getHTMLElement() {
        return this.ellipseHTML.baseCanvas;
    }
}


